import React, { SetStateAction, useEffect, useRef, useState } from "react";
import { Table, Button, Modal, Segment, Icon } from "semantic-ui-react";
import LocalStorage from "../../../../../../lib/LocalStorage";
import config from "../../../../../../common/repository/config";
import FileLabel from "../../../../../common/FileLabel";
import moment from "moment";
import { toast } from "../../../../../common/Toast";
import { io, Socket } from "socket.io-client";
interface ApiResponse {
  success: boolean;
  message: string | null;
  starred?: boolean;
  data: {
    total_item_count: number;
    items: Recording[];
  };
}


interface Recording {
  [x: string]: any;
  direction: string;
  caller_number: string;
  caller_name: string;
  receiver_number: string;
  receiver_name: string;
  receiver_role: string;
  call_start_date: string;
  call_start_time: string;
  call_end_time: string;
  call_duration: string;
  status: string;
  data_source: string;
  call_type: string;
  account_id: string;
  resource_url: string;
  event_id: string;
  call_id: string;
  receiver_id: string;
}

export interface SendChatPayload {
  caseId: string;
  receiverName: string;
  receiverRole: string;
  receiverNumber: string;
}
interface Template {
  [x: string]: SetStateAction<string>;
  id: string;
  name: string;
}
const IvrRecording: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [recordings, setRecordings] = useState<Recording[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [remarks, setRemarks] = useState<{ [key: string]: string }>({});
  const [selectedRecordingId, setSelectedRecordingId] = useState<string | null>(
    null
  );
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [downloading, setDownloading] = useState(false);
  const [open, setOpen] = useState(false);
  const [name, setName] = useState<string>("");
  const [sheet, setSheet] = useState<File | null>(null);
  const [messages, setMessages] = useState<any[]>([]);
  const [receiverId, setReceiverId] = useState<string>("");
  const [showStarred, setShowStarred] = useState(false);
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [showOptions, setShowOptions] = useState(false);
  const [templates, setTemplates] = useState<Template[]>([]);
  const [sendMessage, setSendMessage] = useState("");
  const [showTemplateList, setShowTemplateList] = useState(false);
  const [receiverRole, setReceiverRole] = useState<string | null>(null);
  const [recordingStatus, setRecordingStatus] = useState<string | null>(null);
  const [noDataMessage, setNoDataMessage] = useState<string | null>(null);
  const [serverMessage, setServerMessage] = React.useState("");
  const [selectedTemplateName, setSelectedTemplateName] = useState("");
  const [selectedReceiver, setSelectedReceiver] = useState({
    name: "",
    role: "",
    number: "",
    caseId: "",
  });

  const [previewURL, setPreviewURL] = useState<string | null>(null);
  const [isWindowOpen, setIsWindowOpen] = useState(true);
  const [lastMessageReceivedTime, setLastMessageReceivedTime] = useState<Date | null>(null);
  const [hasUserReplied, setHasUserReplied] = useState(false); 
  const handleFileClick = () => {
    fileInputRef.current?.click();
    setShowOptions(false);
  };

  const isInputEnabled = () => {
    if (!lastMessageReceivedTime) return false;

    const now = new Date();
    const windowEnd = new Date(lastMessageReceivedTime.getTime() + 24 * 60 * 60 * 1000);

    return now >= lastMessageReceivedTime && now <= windowEnd;
  };

  const getMessageDate = (msg: any): Date | null => {
    const raw = msg?.created_on || msg?.timestamp || msg?.time || msg?.status?.[0]?.time;
    if (!raw) return null;
    const d = new Date(raw);
    return isNaN(d.getTime()) ? null : d;
  };

  const addLocalOutgoingMessage = (payload: { message?: string; image?: string }) => {
    const tempMessage = {
      message_id: `temp-${Date.now()}`,
      by: { by_type: "sender", name: "" },
      message: payload.message || "",
      image: payload.image,
      status: [{ type: "sent", time: new Date().toISOString() }],
      created_on: new Date().toISOString(),
      temp: true,
    } as any;
    setMessages((prev) => [...prev, tempMessage]);
  };

  const canSendImageNow = () => !!sheet;

  const canSendTemplateNow = () => {
    return !!selectedTemplateName;
  };



  const socket: Socket = io(config.apiBaseURLSocket);
  useEffect(() => {
    if (!socket) return;

    const handleConnect = () => {
      console.log("Socket connected of ReciverId");
    };

    socket.on("connect", handleConnect);

    return () => {
      socket.off("connect", handleConnect);
    };
  }, [socket]);

  useEffect(() => {
    const caseId = window.location.href.split("/").pop();
    const fetchRecordings = async () => {
      setLoading(true);
      setError(null);
      try {
        const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);
        if (!token) {
          setError("Authentication token is missing.");
          setLoading(false);
          return;
        }
        const response = await fetch(
          `${config.apiBaseURL}/case/listRecording`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "x-access-token": token,
            },
            body: JSON.stringify({ caseId }),
          }
        );
        if (!response.ok) throw new Error("Failed to fetch recordings.");
        const data: ApiResponse = await response.json();

        const recordingsItems = data.data.items || [];
        if (data.success && recordingsItems.length > 0) {
          setRecordings(recordingsItems);
          setRecordingStatus(recordingsItems[0].status.toUpperCase());
        } else {
          setError("No recordings found.");
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    fetchRecordings();
  }, []);

  const fetchWhatsAppConversation = async (receiver: {
    [x: string]: any;
    name: string;
    role: string;
    number: string;
    caseId: string

  }) => {
    setLoading(true);
    setError(null);
    try {
      const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);
      if (!token) {
        setError("Authentication token is missing.");
        setLoading(false);
        return;
      }
      const caseId = window.location.href.split("/").pop();
      const response = await fetch(
        `${config.apiBaseURL}/whatsapp/listConversation`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-access-token": token,
          },
          body: JSON.stringify({
            caseId,
            receiverRole: receiver.role,
            receiverNumber: receiver.number,
            receiverName: receiver.name,
          }),
        }
      );
      const result = await response.json();


      if (!response.ok) {
        setServerMessage("");
        toast.error(result?.message || "Something went wrong");
      } else {
        setServerMessage("");
      }
      const items = result?.data?.items || [];
      setIsWindowOpen(items[0].window_open)
      
      const receiverIdFromResult = items?.receiver_id || "";
      setOpen(true);

      if (socket) {
        const receiverIdFromResult = result?.data?.items?.[0]?.receiver_id || "";
        setReceiverId(receiverIdFromResult);
        socket.emit("join_room",
          receiverIdFromResult,
        );
        socket.off("new_message");
        socket.on("new_message", (msg) => {
          console.log("Real-time message:", msg);

          if (msg.status_type === "read") {
            setMessages((prevMessages) =>
              prevMessages.map((m) =>
                m.message_id === msg.message_id
                  ? { ...m, status_type: "read" }
                  : m
              )
            );
          } else {
            const incomingByType = (value: any) => value && String(value).toLowerCase() !== "sender";
            const isReceiverMessage = (msg?.by && incomingByType(msg.by.by_type)) ||
              (Array.isArray(msg) && msg[0]?.conversation && incomingByType(msg[0].conversation[0]?.by?.by_type));

            if (isReceiverMessage) {
              const parsed = Array.isArray(msg) && msg[0]?.conversation ? getMessageDate(msg[0].conversation[0]) : getMessageDate(msg);
              setLastMessageReceivedTime(parsed || new Date());
            }

            if (
              Array.isArray(msg) &&
              msg.length > 0 &&
              msg[0]?.conversation &&
              Array.isArray(msg[0].conversation) &&
              msg[0].conversation.length > 0
            ) {
              setMessages((prev) => {
                const newMessage = msg[0].conversation[0];
                const messageExists = prev.some(m => m.message_id === newMessage.message_id);
                if (messageExists) return prev;

                const filtered = prev.filter(m => !(m.temp && (
                  (newMessage.message && m.message === newMessage.message) ||
                  (newMessage.image && m.image === newMessage.image)
                )));

                return [...filtered, newMessage];
              });
            } else {
              console.warn("Invalid or missing message format:", msg);
            }
          }
        });
      }
      setReceiverRole(receiver.role.toUpperCase());
      const conversation = result?.data?.items?.[0]?.conversation || [];
      setMessages(conversation);
      
      const lastReceiverMessage = conversation
        .filter((msg: any) => String(msg?.by?.by_type || "").toLowerCase() !== "sender")
        .sort((a: any, b: any) => {
          const da = getMessageDate(a)?.getTime() || 0;
          const db = getMessageDate(b)?.getTime() || 0;
          return db - da;
        })[0];
      
      if (lastReceiverMessage) {
        setLastMessageReceivedTime(getMessageDate(lastReceiverMessage) || new Date());
      }
      
      setSelectedReceiver(receiver);
      setOpen(true);
    } catch (error) {
      console.error("WhatsApp listing error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleTemplateClick = async () => {
    console.log("Select Template clicked");
    setShowOptions(false);
    setShowTemplateList(false);
    setLoading(true);
    setNoDataMessage(null);
    setTemplates([]);

    try {
      const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);
      if (!token) throw new Error("Authentication token is missing.");

      if (!receiverRole) {
        setNoDataMessage("Receiver role not found.");
        setLoading(false);
        return;
      }
      const payload = {
        type: receiverRole,
        status: recordingStatus === "BUSY" ? "ANSWERED" : "NOT ANSWERED",
      };
      console.log(receiverRole, "lower Case", recordingStatus)

      const response = await fetch(`${config.apiBaseURL}/template`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
        body: JSON.stringify(payload),
      });
      const result = await response.json();
      console.log(result, "this is result");

      if (!response.ok) {
        const errorMessage = result?.message || "Failed to fetch templates.";
        setNoDataMessage(errorMessage);
        return;
      }

      const items: Template[] = result?.data?.items || [];
      if (items.length === 0) {
        setNoDataMessage(result?.message || "No templates found.");
        return;
      }

      setTemplates(items);
      setShowTemplateList(true);
    } catch (error) {
      console.error("Fetch error:", error);
      toast.error("Failed to load templates");
    } finally {
      setLoading(false);
    }
  };
  const handleTemplateSelect = async (templateName: string, receiver: {
    name: string;
    role: string;
    number: string;
  }) => {
    try {
      const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);
      if (!token) throw new Error("Authentication token is missing.");

      const caseId = window.location.href.split("/").pop();
      if (!caseId || !receiver.name || !receiver.role || !receiver.number) {
        toast.error("Missing required data to send the message.");
        return;
      }
      const payload = {
        caseId,
        receiverName: receiver.name,
        receiverRole: receiver.role,
        receiverNumber: receiver.number,
        templateName,
      };
      console.log("Sending template message:", payload);

      const response = await fetch(`${config.apiBaseURL}/whatsapp/sendTemplate`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();
      console.log("Manual send result:", result);

      if (!response.ok) {
        toast.error(result?.message || "Failed to send template.");
        return;
      }
    } catch (error) {
      console.error("Send error:", error);
      toast.error("Failed to send the template.");
    }
  };

  const handleSendMessage = async () => {
    if (!sendMessage || !selectedReceiver?.number) {
      toast.error("Please enter a message and select a receiver.");
      return;
    }

    const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);
    if (!token) {
      toast.error("Authentication token is missing.");
      return;
    }

    const caseId = window.location.href.split("/").pop();
    if (!caseId || !selectedReceiver.name || !selectedReceiver.role || !selectedReceiver.number) {
      toast.error("Missing required data to send the message.");
      return;
    }

    const payload = {
      caseId,
      msg: sendMessage,
      receiverName: selectedReceiver.name,
      receiverRole: selectedReceiver.role,
      receiverNumber: selectedReceiver.number
    };

    try {
      const response = await fetch(`${config.apiBaseURL}/whatsapp/message`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();
      console.log("Message send result:", result);

      if (!response.ok) {
        toast.error(result?.message || "Failed to send message.");
        return;
      }
      setSendMessage("");
    } catch (error) {
      console.error("Send error:", error);
      toast.error("Failed to send the message.");
    }
  };

  const handleSendImage = async () => {
    const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);
    if (!token) {
      toast.error("Authentication token is missing.");
      return;
    }

    const caseId = selectedReceiver.caseId || window.location.href.split("/").pop();
    if (!caseId || !selectedReceiver.name || !selectedReceiver.role || !selectedReceiver.number || !sheet) {
      toast.error("Missing required data to send the message.");
      return;
    }

    const formData = new FormData();
    formData.append("caseId", caseId);
    formData.append("receiverName", selectedReceiver.name);
    formData.append("receiverRole", selectedReceiver.role);
    formData.append("receiverNumber", selectedReceiver.number);
    formData.append("sheet", sheet);

    try {
      const response = await fetch(`${config.apiBaseURL}/whatsapp/sendMedia`, {
        method: "POST",
        headers: {
          "x-access-token": token,
        },
        body: formData,
      });

      const result = await response.json();
      console.log("Message send result:", result);
      if (fileInputRef.current) {
        fileInputRef.current.value = ""; // Reset file input
      }
      if (!response.ok) {
        toast.error(result?.message || "Failed to send message.");
        return;
      }

      setHasUserReplied(true); // Mark that user has replied
      setSendMessage("");
    } catch (error) {
      console.error("Send error:", error);
      toast.error("Failed to send the message.");
    }
  };


  const handlechatDownload = async (actualReceiverId: string) => {
    setDownloading(true);
    try {
      const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);
      if (!token) {
        console.error("Authentication token is missing.");
        return;
      }

      const response = await fetch(`${config.apiBaseURL}/whatsapp/download`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
        body: JSON.stringify({ receiverId: actualReceiverId }),
      });

      if (!response.ok)
        throw new Error(`Failed to download: ${response.statusText}`);
      const disposition = response.headers.get("Content-Disposition");
      let fileName = "WhatsAppChat.zip";

      if (disposition && disposition.includes("attachment")) {
        const match = disposition.match(
          /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
        );
        if (match != null && match[1]) {
          fileName = match[1].replace(/['"]/g, "");
        }
      }
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error in handlechatDownload:", error);
    } finally {
      setDownloading(false);
    }
  };

  const getRemarks = async (id: string) => {
    try {
      const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);
      if (!token) {
        console.error("Authentication token is missing.");
        return;
      }
      const response = await fetch(`${config.apiBaseURL}/case/listRecRemark`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
        body: JSON.stringify({ id }),
      });

      if (!response.ok) {
        throw new Error("Failed to fetch remarks.");
      }

      const data = await response.json();
      if (data.success && data.data?.items.length > 0) {
        setRemarks((prevRemarks) => ({
          ...prevRemarks,
          [id]: data.data.items[0].remark,
        }));
      } else {
        setRemarks((prevRemarks) => ({
          ...prevRemarks,
          [id]: "No remarks available",
        }));
      }
    } catch (error) {
      console.error("Error fetching remarks:", error);
    }
  };

  const exportExcelRec = async (caseId: string) => {
    if (!caseId) {
      console.error("Case ID is missing.");
      return;
    }

    try {
      const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);
      if (!token) {
        console.error("Authentication token is missing.");
        return;
      }
      const response = await fetch(`${config.apiBaseURL}/case/exportExcelRec`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
        body: JSON.stringify({
          caseId,
        }),
      });
      if (!response.ok) {
        throw new Error(`Failed to download: ${response.statusText}`);
      }
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      const disposition = response.headers.get("Content-Disposition");
      
      let fileName = `Evidence ${caseId}`;
      if (disposition && disposition.indexOf("attachment") !== -1) {
        const parts = disposition.split(";");
        for (let part of parts) {
          part = part.trim();
          if (part.startsWith("filename=")) {
            fileName = part.substring(9).replace(/['"]/g, "");
          }
        }
      }

      a.download = `${fileName}`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
      console.log("ZIP file downloaded successfully");
    } catch (error) {
      console.error("Error in handleBulkDownload:", error);
    } finally {
      setDownloading(false);
    }
  };

  const handleOpenRemarks = async (id: string) => {
    setSelectedRecordingId(id);
    await getRemarks(id);
    setIsModalOpen(true);
  };
  const toggleStar = (messageId: string) => {
    setMessages((prevMessages) =>
      prevMessages.map((msg) =>
        msg.message_id === messageId ? { ...msg, starred: msg.starred } : msg
      )
    );
    console.log(messageId, "ppp");
  };


  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;
  return (
    <div>
      <div
        style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "30px" }} >
        <h2 style={{ margin: 3 }}>All IVR Recordings Regarding this Case</h2>
        <Button
          style={{ backgroundColor: "#2185d0", color: "white", margin: "10px" }}
          disabled={recordings.length === 0}
          onClick={() =>
            exportExcelRec(window.location.href.split("/").pop() || "")
          }
        >
          Export to Excel
        </Button>
      </div>
      <Segment>
        <Table celled>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Direction</Table.HeaderCell>
              <Table.HeaderCell>Caller Name</Table.HeaderCell>
              <Table.HeaderCell>Caller Number</Table.HeaderCell>
              <Table.HeaderCell>Receiver Name</Table.HeaderCell>
              <Table.HeaderCell>Receiver Role</Table.HeaderCell>
              <Table.HeaderCell>Receiver Number</Table.HeaderCell>
              <Table.HeaderCell>Call Start Date</Table.HeaderCell>
              <Table.HeaderCell>Call Start Time</Table.HeaderCell>
              <Table.HeaderCell>Duration</Table.HeaderCell>
              <Table.HeaderCell>Status</Table.HeaderCell>
              <Table.HeaderCell>Recordings</Table.HeaderCell>
              <Table.HeaderCell>Chat</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {recordings.length === 0 ? (
              <Table.Row>
                <Table.Cell
                  colSpan="11"
                  style={{ textAlign: "center", fontWeight: "bold", color: "rgb(146 135 135 / 50%)" }}
                >
                  {error ? error : "No recordings found"}
                </Table.Cell>
              </Table.Row>
            ) : (
              recordings.map((recording) => (
                <Table.Row key={recording._id}>
                  <Table.Cell>{recording.direction}</Table.Cell>
                  <Table.Cell>{recording.caller_name}</Table.Cell>
                  <Table.Cell>{recording.caller_number}</Table.Cell>
                  <Table.Cell>{recording.receiver_name}</Table.Cell>
                  <Table.Cell>{recording.receiver_role}</Table.Cell>
                  <Table.Cell>{recording.receiver_number}</Table.Cell>
                  <Table.Cell>{recording.call_start_date}</Table.Cell>
                  <Table.Cell>{recording.call_start_time}</Table.Cell>
                  <Table.Cell>
                    {(() => {
                      const duration = moment.duration(
                        Number(recording.call_duration),
                        "seconds"
                      );
                      return `${duration.minutes()} min ${duration.seconds()} sec`;
                    })()}
                  </Table.Cell>
                  <Table.Cell>
                    <span
                      style={{
                        color:
                          recording.status === "ANSWERED" ? "green" : "black",
                        cursor:
                          recording.status === "ANSWERED"
                            ? "pointer"
                            : "default",
                        fontWeight: "bold",
                      }}
                      onClick={() =>
                        recording.status === "ANSWERED" &&
                        handleOpenRemarks(recording._id)
                      }
                    >
                      {recording.status}
                    </span>
                  </Table.Cell>
                  <Table.Cell>
                    {recording.resource_url ? (
                      <FileLabel.Group horizontal>
                        <a
                          href={recording.resource_url}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ textDecoration: "none", color: "inherit" }}
                        >
                          <FileLabel
                            title={
                              recording.resource_url
                                .split("/")
                                .pop()
                                ?.slice(0, 30) || "Recording"
                            }
                            link={recording.resource_url}
                            color={
                              recording.resource_url.endsWith(".mp3")
                                ? "#FF0000"
                                : "#00b5ad"
                            }
                            removable={false}
                          />
                        </a>
                      </FileLabel.Group>
                    ) : (
                      "N/A"
                    )}
                  </Table.Cell>
                  <Table.Cell>
                    <i
                      className="fab fa-whatsapp"
                      style={{
                        color: "#25D366", fontSize: "36px", cursor: "pointer",
                      }}
                      onClick={() => {
                        setName(recording.receiver_name);
                        fetchWhatsAppConversation({
                          name: recording.receiver_name,
                          role: recording.receiver_role,
                          number: recording.receiver_number,
                          caseId: recording.caseId
                        });
                      }}
                    ></i>
                  </Table.Cell>
                  <Table.Cell></Table.Cell>
                </Table.Row>
              ))
            )}
          </Table.Body>
        </Table>
      </Segment>
      {/* Modal to display remarks */}
      <Modal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        size="small"
      >
        <Modal.Header>Remark</Modal.Header>
        <Modal.Content>
          <p>{remarks[selectedRecordingId!] || "No remarks available"}</p>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => setIsModalOpen(false)}>Close</Button>
        </Modal.Actions>
      </Modal>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        size="small"
        style={{ backgroundImage: "url(/whatsapp.jpeg)", backgroundSize: "cover", position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: "350px", height: "500px", margin: "0", borderRadius: "20px", overflow: "hidden", boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.05)", padding: "0", zIndex: 1001 }}
      >
        <Modal.Content
          style={{ padding: "0", backgroundColor: "transparent", height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between" }}
        >
          {/* Header */}
          <div
            style={{ display: "flex", justifyContent: "space-between", alignItems: "center", backgroundColor: "#075E54", color: "#fff", padding: "10px 15px", fontWeight: "bold", fontSize: "16px", borderTopLeftRadius: "20px", borderTopRightRadius: "20px" }}

          >
            {open && <div>{name}</div>}
            <Icon
              className="download"
              onClick={() => handlechatDownload(receiverId)}
              disabled={downloading}
              loading={downloading}
            ></Icon>
            <Button
              icon="close"
              onClick={() => {
                if (socket && receiverId) {
                  socket.emit("leave_chat", receiverId);
                  console.log("Left chat with receiverId:", receiverId);
                }
                // Reset transient UI state on cancel/close
                setSendMessage("");
                setSelectedTemplateName("");
                setShowTemplateList(false);
                setShowOptions(false);
                setSheet(null);
                setPreviewURL(null);
                if (fileInputRef.current) {
                  fileInputRef.current.value = "";
                }
                setOpen(false);
              }}
              style={{
                backgroundColor: "transparent", color: "#FF0000", boxShadow: "none",
              }}
            />
          </div>
          {/* Chat Body */}
          <div
            style={{
              flexGrow: 1,
              padding: "10px",
              backgroundColor: "rgba(255, 255, 255, 0.85)",
              overflowY: "auto",
              minHeight: 0,
              display: "flex",
              flexDirection: "column",
              gap: "20px",
            }}
          >
            {messages.length === 0 ? (
              <div style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                color: "#7d7d7d",
                marginTop: "20px",
              }}>
                <div style={{ fontSize: "14px", fontWeight: 600 }}>No messages yet</div>
                <div style={{ fontSize: "12px" }}>Send a template to start the conversation.</div>
              </div>
            ) : null}
            {messages.map((msg, index) => {
              const isSender = msg.by?.by_type === "sender";
              const status = msg.status?.[0];
              const isSent = status?.type === "sent";
              const time = status?.time;
              return (
                <div
                  key={msg.message_id}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: isSender ? "flex-end" : "flex-start",
                    maxWidth: "75%",
                    marginRight: isSender ? "0" : "auto",
                    marginLeft: isSender ? "auto" : "0",
                  }}
                >
                  <div
                    style={{
                      backgroundColor: isSender ? "#DCF8C6" : "#FFFFFF",
                      padding: "10px 15px",
                      borderRadius: "10px",
                      boxShadow: "0 1px 1px rgba(0,0,0,0.1)",
                      color: "#000",
                      wordBreak: "break-word",
                      width: "100%",
                      position: "relative",
                    }}
                  >
                    {(msg.by?.name || msg.by?.role) && (
                      <div style={{ marginBottom: "6px" }}>
                        <div>
                          <span style={{ fontSize: "13px", fontWeight: 600, color: "#128C7E" }}>
                            <b>{msg.by?.name}</b>
                          </span>
                          {msg.by?.role && (
                            <span style={{ fontSize: "12px", color: "#555", marginLeft: "6px" }}>
                              ({msg.by.role})
                            </span>
                          )}
                        </div>

                      </div>
                    )}

                    {/* message content */}
                    <>
                      {/* FileLabel group for image */}
                      {/* {(msg.message && /\.(jpg|jpeg|png|webp|gif|mp4|mp3|docx|ogg)$/i.test(msg.message.trim())) || msg.image ? ( */}
                      {(/\.[^.\s]{2,5}$/i.test(msg.message?.trim() || "") || msg.image) ? (
                        <FileLabel.Group horizontal>
                          {/* File from msg.message */}
                          {msg.message && (
                            <FileLabel
                              title={msg.message.trim().split("/").pop()?.slice(0, 30) || "File"}
                              link={`http://verifacto.amable.in/${msg.message.trim()}`}
                              color="#2185d0"
                              removable={false}
                            />
                          )}

                          {/* File from msg.image */}
                          {msg.image && (
                            <FileLabel
                              title={msg.image.trim().split("/").pop()?.slice(0, 30) || "Image"}
                              link={msg.image.trim()}
                              color="#2185d0"
                              removable={false}
                            />
                          )}
                        </FileLabel.Group>
                      ) : (
                        <span>
                          {msg.message}
                          {msg.message_subject && ` ${msg.message_subject}`}
                        </span>
                      )}
                      {/* Contact */}
                      {msg.contact && (
                        <>
                          {" "}
                          | <span>{`${msg.contact.name} (${msg.contact.number})`}</span>
                        </>
                      )}

                      {/* Location */}
                      {msg.location && (
                        <>

                          <FileLabel
                            title="📍 View Location"
                            link={`https://www.google.com/maps?q=${msg.location.latitude},${msg.location.longitude}`}
                            color="#f2711c"
                            removable={false}
                          />
                        </>
                      )}
                    </>
                    {/* reactions */}
                    {msg.reactions && msg.reactions.length > 0 && (
                      <div
                        style={{
                          display: "flex",
                          gap: "6px",
                          marginTop: "6px",
                          flexWrap: "wrap",
                        }}
                      >
                        {msg.reactions.map((reaction: { _id: any; reacted_by: { name: any; role: any; }; emoji: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal | null | undefined; }, i: any) => (
                          <div
                            key={reaction._id || i}
                            style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", padding: "4px 8px", backgroundColor: "#fff", borderRadius: "12px", boxShadow: "0 1px 2px rgba(0,0,0,0.1)", fontSize: "15px", cursor: "default" }}

                            title={`${reaction.reacted_by?.name} (${reaction.reacted_by?.role || "User"})`}
                          >
                            {reaction.emoji}
                          </div>
                        ))}
                      </div>
                    )}
                    {/* timestamp and read status */}
                    {msg.status && msg.status.length > 0 && (
                      <div
                        style={{
                          fontSize: "11px",
                          color: "#777",
                          display: "flex",
                          justifyContent: "flex-end",
                          alignItems: "center",
                          marginTop: "6px",
                        }}
                      >
                        <span>{time}</span>

                        {isSender && (() => {
                          const latestStatus = msg.status[msg.status.length - 1]?.type;

                          let icon = "✔";
                          let color = "#D6D3C7"; // default gray

                          if (latestStatus === "read") {
                            icon = "✔✔";
                            color = "#34B7F1"; // blue colour
                          } else if (latestStatus === "delivered") {
                            icon = "✔✔";
                            color = "#D6D3C7"; // gray colour
                          } else if (latestStatus === "sent") {
                            icon = "✔";
                            color = "#D6D3C7"; // gray colour
                          }
                          return (
                            <span style={{ fontSize: "14px", marginLeft: "6px", color }}>{icon}</span>
                          );
                        })()}
                      </div>
                    )}
                    {!isSender && msg.created_on && (
                      <div style={{ fontSize: "11px", color: "#999", marginTop: "2px" }}>
                        {msg.created_on}
                      </div>
                    )}
                    {/* star icon */}
                    {/* {!isSender && (
                      <Icon
                        name={msg.starred ? "star" : "star outline"}
                        color={msg.starred ? "yellow" : "grey"}
                        style={{ position: "absolute", bottom: "6px", right: "8px", cursor: "pointer", fontSize: "1.2em" }}

                        title={
                          msg.starred ? "Unstar message" : "Star message"
                        }
                        onClick={() => toggleStar(msg.message_id)}
                      />
                    )} */}
                  </div>
                </div>
              );
            })}
          </div>


          {/* Footer */}


          <div
            style={{ display: "flex", alignItems: "center", padding: "10px", borderBottomLeftRadius: "20px", borderBottomRightRadius: "20px", position: "relative", backgroundColor: "rgba(255, 255, 255, 0.85)", zIndex: 10 }}

          >
            {/* Chat Input Box */}
            <div
              style={{ display: "flex", alignItems: "center", flex: 1, padding: "8px 12px", borderRadius: "25px", marginRight: "10px", backgroundColor: "#fff", position: "relative" }}
            >
              {/* Options Icon */}
              <div style={{ position: "relative" }}>
                <div
                  onClick={() => setShowOptions((prev) => !prev)}
                  style={{
                    cursor: "pointer",
                    width: 28,
                    height: 28,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "50%",
                    background: showOptions ? "#e8f5e9" : "#f2f2f2",
                    color: "#2e7d32",
                    fontSize: 18,
                    fontWeight: 700,
                    userSelect: "none",
                    transition: "all .15s ease-in-out",
                  }}
                  title={showOptions ? "Close" : "More"}
                >
                  +
                </div>
                {/* Options Dropdown */}
                {showOptions && (
                  <div
                    style={{
                      position: "absolute",
                      bottom: 36,
                      left: 0,
                      backgroundColor: "#ffffff",
                      border: "1px solid #eaeaea",
                      boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                      borderRadius: 12,
                      zIndex: 100,
                      overflow: "hidden",
                      minWidth: 180,
                    }}
                  >
                    <div style={{ padding: 12 }}>
                      {/* File Picker */}
                      <label
                        htmlFor="fileInput"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                          padding: "10px 12px",
                          backgroundColor: "#f7f7f7",
                          borderRadius: 8,
                          cursor: "pointer",
                          border: "1px solid #e3e3e3",
                          fontSize: 14,
                          color: "#333",
                          transition: "background .15s ease-in-out",
                        }}
                        onMouseEnter={(e:any)=>{ e.currentTarget.style.backgroundColor = '#efefef' }}
                        onMouseLeave={(e:any)=>{ e.currentTarget.style.backgroundColor = '#f7f7f7' }}
                      >
                        <i className="image outline icon" style={{ color: "#2185d0" }}></i>
                        Choose Image
                      </label>
                      <input
                        id="fileInput"
                        type="file"
                        accept="image/*"
                        style={{ display: "none" }}
                        onChange={(e) => {
                          if (e.target.files && e.target.files[0]) {
                            setSheet(e.target.files[0]);
                            setPreviewURL(URL.createObjectURL(e.target.files[0])); // make sure you define this in your state
                          }
                        }}
                      />
                      {/* Preview */}
                      {previewURL && (
                        <div style={{ marginTop: 12 }}>
                          <img
                            src={previewURL}
                            alt="Preview"
                            style={{
                              width: 160,
                              height: "auto",
                              borderRadius: 8,
                              border: "1px solid #ddd",
                              boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
                            }}
                          />
                        </div>
                      )}
                    </div>
                    <div
                      onClick={handleTemplateClick}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        padding: "10px 12px",
                        cursor: "pointer",
                        whiteSpace: "nowrap",
                        borderRadius: 8,
                        marginTop: 8,
                      }}
                      onMouseEnter={(e:any)=>{ e.currentTarget.style.backgroundColor = '#f7f7f7' }}
                      onMouseLeave={(e:any)=>{ e.currentTarget.style.backgroundColor = 'transparent' }}
                    >
                      <i className="file alternate outline icon" style={{ color: "#21ba45" }}></i>
                      Select Template
                    </div>
                  </div>
                )}
                {showTemplateList && templates.length > 0 && (
                  <div
                    style={{ position: "absolute", bottom: 110, left: 0, backgroundColor: "#ffffff", border: "1px solid #eaeaea", borderRadius: 12, maxHeight: 220, overflowY: "auto", zIndex: 101, width: 300, boxShadow: "0 8px 24px rgba(0,0,0,0.12)" }}
                  >
                    {templates.map((template) => (
                      <div
                        key={template.id}
                        onClick={() => {
                          setSelectedTemplateName(template.name);
                          setTemplates((prevTemp) =>
                            prevTemp.filter((t) => t.id !== template.id)
                          );

                        }}
                        style={{ padding: "10px 12px", cursor: "pointer", borderBottom: "1px solid #f2f2f2" }}
                        onMouseEnter={(e:any)=>{ e.currentTarget.style.backgroundColor = '#f7f7f7' }}
                        onMouseLeave={(e:any)=>{ e.currentTarget.style.backgroundColor = 'transparent' }}
                      >
                        {template.name}
                      </div>
                    ))}
                  </div>
                )}
              </div>
              {/* Message Input */}
              <input
                type="text"
                value={sendMessage}
                placeholder="Type a message"
                onChange={e => setSendMessage(e.target.value)}
                disabled={!isWindowOpen}
                // allow editing input
                style={{
                  flex: 1, padding: "10px", border: "none", borderRadius: "20px", fontSize: "14px", outline: "none", backgroundColor: isInputEnabled() ? "transparent" : "#f0f0f0",
                  cursor: isInputEnabled() ? "text" : "not-allowed",
                }}
              />
            </div>

            {/* Send Button */}
            <button
              onClick={async () => {
                const canSendAny = isInputEnabled() || canSendTemplateNow() || canSendImageNow();
                if (!canSendAny) return; 
             
                try {
                  if (selectedReceiver?.number) {
                    await fetchWhatsAppConversation(selectedReceiver);
                  }
                } catch (e) {
                  console.warn("Pre-send refresh failed", e);
                }
                
                if (selectedTemplateName) {
                  // setIsProcessing(true); 
                  await handleTemplateSelect(selectedTemplateName, selectedReceiver);
                  toast.success("Template sent successfully");
                  // Refresh immediately so the template appears from server
                  try {
                    if (selectedReceiver?.number) {
                      await fetchWhatsAppConversation(selectedReceiver);
                    }
                  } catch {}
                  // Reset template-related UI and exit early so free-form send below doesn't run
                  setSelectedTemplateName("");
                  setShowTemplateList(false);
                  return;
                }


                if (sheet && canSendImageNow()) {
                  console.log("Sheet exists, calling handleSendImage", sheet);
                  addLocalOutgoingMessage({ image: previewURL || "" });
                  await handleSendImage();
                  setSheet(null);
                  setPreviewURL(null);
                  setShowOptions(false);
                  setShowTemplateList(false);
                  setSelectedTemplateName("");

                  if (fileInputRef.current) {
                    fileInputRef.current.value = ""; // Reset file input
                  }
                }

                if (sendMessage.trim()) {
                  addLocalOutgoingMessage({ message: sendMessage.trim() });
                  handleSendMessage();
                }

                setSendMessage("");
                setSelectedTemplateName("");
                setShowTemplateList(false);
                // setIsProcessing(false);
              }}
              disabled={!(isInputEnabled() || canSendTemplateNow() || canSendImageNow())}
              style={{
                border: "none",
                borderRadius: "50%",
                padding: "12px",
                cursor: (isInputEnabled() || canSendTemplateNow() || canSendImageNow()) ? "pointer" : "not-allowed",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: (isInputEnabled() || canSendTemplateNow() || canSendImageNow()) ? "#25D366" : "#ccc",
                color: "#fff",
                opacity: (isInputEnabled() || canSendTemplateNow() || canSendImageNow()) ? 1 : 0.6,
              }}
            >
              <i className="send icon" style={{ fontSize: "16px" }}></i>
            </button>
          </div>
        </Modal.Content>
      </Modal>
    </div>
  );
};

export default IvrRecording;
